import React from "react";

import { useRecoilValue, useRecoilState } from "recoil";

import Checkbox from "@mui/material/Checkbox";

import Box from "@mui/material/Box";
import { IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import ContrastIcon from "@mui/icons-material/Contrast";

import {
  layerDefLabelsSelector,
  layerDefFilterByChildrenSelector,
  layerDefFilterStateSelector,
  layerDefVisibilitySelector,
  layerDefsParentColourSelector,
  layerDefInfoSelector,
  layerDefOpacitySelector,
} from "../map/layerAtoms";
import LayerInfo from "./LayerInfo";

export default function CheckboxParent({
  switchCollapseState,
  collapseOpen,
  layerID,
}) {
  const filterByChildren = useRecoilValue(
    layerDefFilterByChildrenSelector(layerID)
  );
  const { parent: parentLabel } = useRecoilValue(
    layerDefLabelsSelector(layerID)
  );
  const [filterState, setFilterState] = useRecoilState(
    layerDefFilterStateSelector(layerID)
  );
  const [visibility, setVisibility] = useRecoilState(
    layerDefVisibilitySelector(layerID)
  );

  const opacity = useRecoilValue(layerDefOpacitySelector(layerID));

  const info = useRecoilValue(layerDefInfoSelector(layerID));

  const colour = useRecoilValue(layerDefsParentColourSelector(layerID));

  const handleParentClickWithChildrenFilters = (event) => {
    if (layerID === 'places') {
      setVisibility(event.target.checked)
    }

    setFilterState((oldFilterState) => {
      const newFilteredState = Object.keys(oldFilterState).reduce((o, key) => {
        o[key] = event.target.checked;
        return o;
      }, {});

      return { ...newFilteredState };
    });
  };

  const handleParentClickWithoutChildrenFilters = (event) => {
    setVisibility(event.target.checked);
  };

  const checkboxProps = filterByChildren
    ? {
        onChange: handleParentClickWithChildrenFilters,
        indeterminate:
          !Object.values(filterState).every((value) => value) &&
          Object.values(filterState).some((value) => value),
        checked: Object.values(filterState).every((value) => value),
      }
    : {
        onChange: handleParentClickWithoutChildrenFilters,
        checked: visibility,
        sx: {
          color: colour,
          "&.Mui-checked": {
            color: colour,
          },
        },
      };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "flex-start",
      }}
    >
      <Checkbox
        sx={{ p: 1 }}
        icon={<CircleOutlinedIcon />}
        checkedIcon={<CircleIcon />}
        indeterminateIcon={<ContrastIcon />}
        {...checkboxProps}
      />
      <Typography sx={{ cursor: "pointer" }} onClick={switchCollapseState}>
        {parentLabel}
      </Typography>

      <LayerInfo {...info} />
      {(filterByChildren || typeof opacity === "number") && (
        <IconButton
          aria-label="Switch Collapse State"
          onClick={switchCollapseState}
        >
          {collapseOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      )}
    </Box>
  );
}
